var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Color, Size } from '../const/';
import Icon from '../icon/icon';
function Toast(_a) {
    var message = _a.message;
    return (React.createElement(StyledToast, null,
        React.createElement(Icon.CheckToast, null),
        React.createElement(Message, null, message)));
}
Toast.defaultProps = {
    message: '完了しました',
};
var StyledToast = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background: #76c60e;\n  border-radius: 8px;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 155px;\n  justify-content: center;\n  width: 155px;\n"], ["\n  align-items: center;\n  background: #76c60e;\n  border-radius: 8px;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 155px;\n  justify-content: center;\n  width: 155px;\n"])), Color.WHITE);
var Message = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-top: 16px;\n"], ["\n  font-size: ", ";\n  margin-top: 16px;\n"])), Size.FONT.BASE);
export default Toast;
var templateObject_1, templateObject_2;
//# sourceMappingURL=toast.js.map